// extracted by mini-css-extract-plugin
export default {"profile":"myProfile_profile__4pLgg","box":"myProfile_box__cRxv+","title-entry":"myProfile_title-entry__qu+Co"};